module.exports = __webpack_public_path__ + "img/4_click_save_and_see_json-1.jpg";